module.exports = __webpack_public_path__ + "img/tarjeta_servicios_declarar_siniestro.28ae993c.jpg";